import React from 'react';

export default function Archive() {
  return <div>hello</div>;
}
